export default `Fidelity Investments
Robinhood
Charles Schwab`.split("\n");